import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./pages/landing/landing.component').then(m => m.LandingComponent),
    children: [
      {
        path: 'ticket-confirmation/:ticketId',
        loadComponent: () => import('./components/ticket-confirmation/ticket-confirmation')
          .then(m => m.TicketConfirmationComponent)
      },
      {
        path: 'ticket-confirmation-trip/:ticketId',
        loadComponent: () => import('./components/ticket-client/ticket-client.component')
          .then(m => m.TicketClientComponent)
      }
      // tu peux ajouter d’autres composants enfants ici
    ]
  },
  
  {
    path: 'fr',
    loadComponent: () => import('./pages/landing/landing.component').then(m => m.LandingComponent)
  },
  {
    path: 'en',
    loadComponent: () => import('./pages/landing/landing.component').then(m => m.LandingComponent)
  },
  {
    path: 'ar',
    loadComponent: () => import('./pages/landing/landing.component').then(m => m.LandingComponent)
  },
    {
    path: 'drivers',
    loadComponent: () => import('./components/list-drivers-accepted/list-drivers-accepted.component').then(m => m.ListDriversAcceptedComponent),
    data: { prerender: false }
  },
  {
    path: ':url',
    loadComponent: () => import('./pages/landing/landing.component').then(m => m.LandingComponent),
    data: { prerender: false }
  },
  {
    path: 'city/:cityName',
      loadComponent: () => import('./pages/landing/landing.component').then(m => m.LandingComponent),
    data: { prerender: false }
  },
  

  {
    path: 'receipt/:ref',
    loadComponent: () => import('./pages/ticket-receipt/ticket-receipt.component').then(m => m.TicketRceiptComponent),
     data: { prerender: false }
  },

];
